/**
 * Phase 1 workflows module — top-level route shell.
 *
 *   /workflows                 → WorkflowsListView
 *   /workflows/:id             → WorkflowEditorView
 *   /workflows/:id?graph=1     → WorkflowEditorView with the graph sheet open
 *                                (Phase 2 wires the actual React Flow viewer)
 *
 * The route shape is set up via nested <Routes> so the page-level component
 * is a thin dispatcher and the views stay self-contained.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { WorkflowsListView } from './workflows/WorkflowsListView.js';
import { WorkflowEditorView } from './workflows/WorkflowEditorView.js';

export function WorkflowsPage() {
  return (
    <Routes>
      <Route index element={<WorkflowsListView />} />
      <Route path=":id" element={<WorkflowEditorView />} />
      <Route path="*" element={<Navigate to="/workflows" replace />} />
    </Routes>
  );
}
